var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    fill: "#FFF7E6",
    stroke: "#FFAE00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24138_194271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4931 17.5069C28.4826 15.4964 25.2114 15.4964 23.2009 17.5069C21.8276 18.8802 21.3506 20.904 21.9453 22.7401L16.1383 28.547C16.0504 28.6349 16.001 28.7539 16.001 28.8785V31.5303C16.001 31.7894 16.2106 31.999 16.4697 31.999H19.1215C19.246 31.999 19.3651 31.9496 19.4529 31.8617L20.1158 31.1984C20.2169 31.0972 20.2664 30.9553 20.2499 30.8129L20.1675 30.1007L21.1544 30.0077C21.3788 29.9867 21.5559 29.8095 21.577 29.5852L21.6699 28.5983L22.3822 28.6811C22.5145 28.6989 22.6477 28.6545 22.7479 28.5658C22.8477 28.4765 22.9049 28.3492 22.9049 28.2156V27.3428H23.7619C23.8864 27.3428 24.0054 27.2934 24.0933 27.2054L25.2954 26.0193C27.131 26.6144 29.1198 26.1733 30.4931 24.7991C32.5036 22.7886 32.5036 19.5174 30.4931 17.5069ZM29.167 20.8216C28.6186 21.37 27.7269 21.37 27.1784 20.8216C26.63 20.2732 26.63 19.3814 27.1784 18.833C27.7269 18.2846 28.6186 18.2846 29.167 18.833C29.7154 19.3814 29.7154 20.2732 29.167 20.8216Z",
    fill: "#FFAE00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24138_194271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningKey);
export default __webpack_public_path__ + "static/media/warning-key.cd73ca48.svg";
export { ForwardRef as ReactComponent };